export default "__VITE_ASSET__CQbBSn11__"